import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import NavHeader from '../components/NavHeader/NavHeader'
import Footer from '../components/Footer/Footer'
import { Outlet } from 'react-router-dom'
import './Layout.css'
import { fetchServerExtensions, fetchExternalServerSettings } from '../redux/slices'
import { AppDispatch } from '../services/lib'

const Layout: React.FC = () => {
  const dispatch: AppDispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchExternalServerSettings())
    dispatch(fetchServerExtensions())
  }, [])

  return (
    <div className='d-flex flex-column min-vh-100'>
      <NavHeader />
      <Outlet />
      <Footer />
    </div>
  )
}

export default Layout